export default {
  'TextCell.Selector.HideWrapper.AddInspection': ({ }, outlet) => {
    outlet({ action: 'create_inspection' })
  },
  'TextCell.Selector.ProgressBar': ({ id }) => {
    window.open(`/inspections/${id}`, "_blank");
  },
}
